import React from 'react'
import '../Assets/Additionalcss/Resetpassword.css'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer,toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';

export const ResetPassword = () => {

  const navigate = useNavigate();

  function handleSubmit(e){
e.preventDefault()

    var newpsw =document.getElementById("rpsw-npsw").value;
    var confirmpsw =document.getElementById("rpsw-cpsw").value;

    if(!newpsw){
      document.getElementById("rpsw-error-np1").innerHTML = "Enter New Password";
    }
    else if (!/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(newpsw)) {
      document.getElementById("rpsw-error-np1").innerHTML = "";
  document.getElementById("rpsw-error-np2").innerHTML = "Invalid Password";
    }
    else{
      document.getElementById("rpsw-error-np1").innerHTML = "";
      document.getElementById("rpsw-error-np2").innerHTML = "";
    }
    if(!confirmpsw){
      document.getElementById("rpsw-error-cp1").innerHTML = "Enter Confirm Password";
    }
    else if(newpsw!==confirmpsw){
      document.getElementById("rpsw-error-cp1").innerHTML = "";
      document.getElementById("rpsw-error-cp2").innerHTML = "Passwords Not Match";
  }
  else{
    document.getElementById("rpsw-error-cp1").innerHTML = "";
    document.getElementById("rpsw-error-cp2").innerHTML = "";
   
    Reset()
  }
}
  function handleChange(){

    var newpsw =document.getElementById("rpsw-npsw").value;
    var confirmpsw =document.getElementById("rpsw-cpsw").value;

    if(!newpsw){
      document.getElementById("rpsw-error-np1").innerHTML = "Enter New Password";
      document.getElementById("rpsw-error-np2").innerHTML = "";
    }
    else if (!/^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(newpsw)) {
      document.getElementById("rpsw-error-np1").innerHTML = "";
  document.getElementById("rpsw-error-np2").innerHTML = "Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    }
    else{
      document.getElementById("rpsw-error-np1").innerHTML = "";
      document.getElementById("rpsw-error-np2").innerHTML = "";
    }
    if(!confirmpsw){
      document.getElementById("rpsw-error-cp1").innerHTML = "Enter Confirm Password";
      document.getElementById("rpsw-error-cp2").innerHTML = "";

    }
    else if(newpsw!==confirmpsw){
      document.getElementById("rpsw-error-cp1").innerHTML = "";
      document.getElementById("rpsw-error-cp2").innerHTML = "Passwords Not Match";
  }
  else{
    document.getElementById("rpsw-error-cp1").innerHTML = "";
    document.getElementById("rpsw-error-cp2").innerHTML = "";  
  }
 
  }
  

  function TcResetnpswhide(){

    var x = document.getElementById("rpsw-npsw");
  
    var eye = document.getElementById("eye-TcResetnpsw");
  
    if(x.type === "password"){
   x.type = "text";
      eye.classList.remove("fa-eye-slash")
      eye.classList.add("fa-eye")
     
   }
    else{
      x.type = "password";
      eye.classList.remove("fa-eye")
      eye.classList.add("fa-eye-slash")
  
    }
   }

   function TcResetcpswhide(){

    var x = document.getElementById("rpsw-cpsw");
  
    var eye = document.getElementById("eye-TcResetcpsw");
  
    if(x.type === "password"){
   x.type = "text";
      eye.classList.remove("fa-eye-slash")
      eye.classList.add("fa-eye")
     
   }
    else{
      x.type = "password";
      eye.classList.remove("fa-eye")
      eye.classList.add("fa-eye-slash")
  
    }

   }

   function Reset()
   {

    var email = localStorage.getItem('email')
    var newpsw =document.getElementById('rpsw-cpsw').value
    console.log(newpsw)

    const body ={
        email: email,
        newPassword: newpsw
      }

      //console.log(body)
      axios({
   
        method:"POST",
      // url:`${BASE_URL}/User/ResetPassword`,
       url:'https://localhost:44312/Api/User/ResetPassword',
       data:body,
       headers: {
       "Content-Type" : "application/json",
      
       }
      
        })
        .then((response) =>{
        console.log(response.data);
       alert('Password Changed Successfully')
       window.location.href="/#/"
       
     
        })

      document.getElementById("rpsw-npsw").value = "";
      document.getElementById("rpsw-cpsw").value = "";
   }


  return (
    <div className="Main-RP" >
    
    <div class="RPdiv">
    <h2 class="login-title">Reset Password</h2>

    <form class="login-form">
    <div>
          <span id="rpsw-error-np1" className='resetpsw-error'></span>
          <span id="rpsw-error-np2"  className='resetpsw-error'></span>
          <input className="mb-2" type="password" name='newpassword' id="rpsw-npsw" onKeyUp={handleChange} placeholder="New password" />
          <span className='Reseteyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={TcResetnpswhide} id="eye-TcResetnpsw"></i></span>
          </div>

     
      <div>
          <span id="rpsw-error-cp1"  className='resetpsw-error'></span>
          <span id="rpsw-error-cp2"  className='resetpsw-error'></span>
          <input className="mb-4" type="password"  id="rpsw-cpsw" name='confirmpassword' onKeyUp={handleChange} placeholder="Confirm password" />
          <span className='Reseteyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={TcResetcpswhide} id="eye-TcResetcpsw"></i></span>
          </div>
      

      <button className="RPbtn" type="submit" onClick={handleSubmit} value="Log in">
      Reset
      </button>
    </form>
</div>
    
    </div>  
  )
}
export default ResetPassword ; 